export default __webpack_public_path__ + "static/media/example.17708d76.csv";